import { createLazyFileRoute } from "@tanstack/react-router";

import { NewWorkflowPage } from "@/features/admin/routes/WorkflowsNew";

export const Route = createLazyFileRoute("/_auth/admin/workflows/new")({
  component: NewWorkflowPage,
});
